// @modified: add qty bonus
// @version V0.0.1 [Thursday - 20201210_165226] : init

import {
    calculateCutResult
} from "../nominalCutter";

import { notify } from "./../../api";

export function checkStockMustNotExceed(qtyToAdd, productItemBaseQty, baseQtyBalance, existedSaleItem = null) {
    let baseQtyToAdd = qtyToAdd * productItemBaseQty;
    let baseQtyAdded = existedSaleItem ? existedSaleItem.qty * productItemBaseQty : 0
    let baseQtyBalanceRemain = baseQtyBalance - baseQtyToAdd - baseQtyAdded;
    if (baseQtyBalanceRemain < 0) {
        notify('error', 'stok yang tersedia tidak mencukupi', 5000)
        return false;
    } else {
        return true;
    }
}

/**
 * 
 * @param {Object} transaction 
 * @param {Array} items 
 * @param {Boolean} hasTaxItem default : true
 */
export function calculateTransaction(transaction, items, hasTaxItem = true) {

    transaction.price_total = hasTaxItem ? _.sumBy(items, 'price_after_tax') : _.sumBy(items, 'price_after_discount')
    // discount
    transaction.discount_nominal_from_total = +calculateCutResult(transaction.discount_word_from_total, transaction.price_total, 'floor');
    transaction.discount_nominal_from_item = _.sumBy(items, 'discount_nominal');
    transaction.discount_nominal = +transaction.discount_nominal_from_item + transaction.discount_nominal_from_total;
    transaction.price_total_after_discount = transaction.price_total - transaction.discount_nominal_from_total; // discount_nominal_from_item already counted

    // tax
    transaction.tax_nominal_from_total = +calculateCutResult(transaction.tax_word_from_total, transaction.price_total_after_discount, 'floor');
    transaction.tax_nominal_from_item = hasTaxItem ? +_.sumBy(items, 'tax_nominal') : 0;
    transaction.tax_nominal = +transaction.tax_nominal_from_item + transaction.tax_nominal_from_total;
    transaction.price_total_after_tax = transaction.price_total_after_discount + transaction.tax_nominal_from_total; // tax_nominal_from_item already counted

    // payment
    transaction.payment_total = transaction.price_total_after_tax;
    // transaction.payment_done 
    transaction.payment_remain = transaction.payment_total - transaction.payment_done;
}

/**
 * 
 * @param {Object} item 
 * @param {String} discountMethod floor | round | ceil | empty if normal 
 * @param {String} taxMethod floor | round | ceil | empty if normal
 * @param {Boolean} hasTax default : true 
 */
export function calculateTransactionItem(item, discountMethod = 'floor', taxMethod = 'floor', hasTax = true) {
    item.qty_total = +item.qty_bonus + +item.qty
    item.price = item.qty * item.n_price;
    item.discount_nominal = _.isEmpty(item.discount_word) ? 0 : calculateCutResult(item
        .discount_word, item.price, discountMethod);
    item.price_after_discount = item.price - item.discount_nominal;

    if (hasTax) {
        item.tax_nominal = _.isEmpty(item.tax_word) ? 0 : calculateCutResult(item.tax_word,
            item.price_after_discount, taxMethod);
        item.price_after_tax = item.price_after_discount + item.tax_nominal;
    }

}

export function calculatePayment(transaction, payments) {
    transaction.payment_total = transaction.price_total_after_tax + transaction.additional_cost_total
    transaction.payment_done = _.sumBy(payments, function (p) {
        return p.status_paid ? p.nominal : 0
    })
    transaction.payment_remain = transaction.payment_total - transaction.payment_done
}
